export default __webpack_public_path__ + "static/media/fuhr3.227b44bf.svg";